const validate = {
  rules: {
    titulo: {
      required: true,
    },
  },
  messages: {
    titulo: "O título é obrigatório.",
  },
};

export default validate;
